import {
  IconArrowsExchange,
  IconBriefcase,
  IconBuildingBank,
  IconCalendarEvent,
  IconCash,
  IconGift,
  IconHome,
  IconHomeStar,
  IconTool,
  IconTrees,
} from '@tabler/icons-react';

import { MainCategory } from './expenseCategorization';

type IconComponent = typeof IconHome;

export const MAIN_CATEGORY_ICONS: Record<MainCategory, IconComponent> = {
  [MainCategory.FixedCosts]: IconBuildingBank,
  [MainCategory.DailyLife]: IconHome,
  [MainCategory.WorksEquipment]: IconTool,
  [MainCategory.FundingCalls]: IconCash,
  [MainCategory.RentalHousing]: IconHomeStar,
  [MainCategory.EventsTourism]: IconCalendarEvent,
  [MainCategory.EstateLands]: IconTrees,
  [MainCategory.Operating]: IconBriefcase,
  [MainCategory.Subsidies]: IconGift,
  [MainCategory.Reimbursements]: IconArrowsExchange,
};

export const EXPENSE_MAIN_CATEGORIES: MainCategory[] = [
  MainCategory.FixedCosts,
  MainCategory.DailyLife,
  MainCategory.WorksEquipment,
];

export const INCOME_MAIN_CATEGORIES: MainCategory[] = [
  MainCategory.FundingCalls,
  MainCategory.RentalHousing,
  MainCategory.EventsTourism,
  MainCategory.EstateLands,
  MainCategory.Operating,
  MainCategory.Subsidies,
  MainCategory.Reimbursements,
];
